import {
  Table,
  Thead,
  Tbody,
  Tr,
  Td,
  Box,
  Text,
  Grid,
  Input,
  InputGroup,
  InputRightAddon,
  HStack,
  IconButton,
  TableContainer,
} from "@chakra-ui/react";
import React from "react";
import { AiFillPlusCircle } from "react-icons/ai";
import FormSelect from "../../formcontrol/select";
import FormCheckBox from "../../formcontrol/checkbox";
import { BsCurrencyDollar } from "react-icons/bs";
import UploadBtn from "./UploadBtn";
import { ImBin } from "react-icons/im";

function PakegesTable() {
  const [packages, setPackages] = React.useState(["Basic"]);
  return (
    <TableContainer
      borderRadius={"20px"}
      ml={4}
      border="1px"
      borderColor="gray.200"
      // borderCollapse="separate"
      display={{ base: "none", md: "block" }}
      
    >
      <Table variant="simple">
        <Thead>
          <Tr>
            <Td
              px={1}
              colSpan={3}
              borderRight="1px"
              borderColor="gray.200"
            ></Td>
            <Td
              px={1}
              borderRight="1px"
              borderColor="gray.200"
              bg="#f4f4f4"
              textAlign={"center"}
            >
              Delivery
            </Td>
            <Td
              px={1}
              borderRight="1px"
              borderColor="gray.200"
              bg="#f4f4f4"
              textAlign={"center"}
            >
              Revisions
            </Td>
            <Td
              px={1}
              borderRight="1px"
              borderColor="gray.200"
              bg="#f4f4f4"
              textAlign={"center"}
            >
              No of Concepts
            </Td>
            <Td
              px={1}
              borderRight="1px"
              borderColor="gray.200"
              bg="#f4f4f4"
              textAlign={"center"}
            >
              Vector file
            </Td>
            <Td
              px={1}
              borderRight="1px"
              borderColor="gray.200"
              bg="#f4f4f4"
              textAlign={"center"}
            >
              Printable file
            </Td>
            <Td
              px={1}
              borderRight="1px"
              borderColor="gray.200"
              bg="#f4f4f4"
              textAlign={"center"}
            >
              Source file
            </Td>
            <Td
              px={1}
              borderRight="1px"
              borderColor="gray.200"
              bg="#f4f4f4"
              textAlign={"center"}
              color="#008ddb"
            >
              Price{" "}
            </Td>
          </Tr>
        </Thead>
        <Tbody>
          {packages?.map((item, index) => {
            //item contain package name
            return (
              <Tr aria-colcount={10} key={index}>
                <Td
                  px={2}
                  borderRight="1px"
                  borderColor="gray.200"
                  textAlign={"center"}
                  bg="#f4f4f4"
                >
                  {item}
                </Td>
                <Td
                  px={1}
                  borderRight="1px"
                  borderColor="gray.200"
                  textAlign={"center"}
                >
                  <Input placeholder="Package Name" w="160px" border={0} />
                </Td>
                <Td
                  px={1}
                  borderRight="1px"
                  borderColor="gray.200"
                  textAlign={"center"}
                >
                  <UploadBtn />
                </Td>
                <Td
                  px={1}
                  borderRight="1px"
                  borderColor="gray.200"
                  textAlign={"center"}
                >
                  <FormSelect placeholder={"2 Days"} border={"none"} />
                </Td>
                <Td
                  px={1}
                  borderRight="1px"
                  borderColor="gray.200"
                  textAlign={"center"}
                >
                  <FormSelect placeholder={"unlimited"} border={"none"} />
                </Td>
                <Td
                  px={1}
                  borderRight="1px"
                  borderColor="gray.200"
                  textAlign={"center"}
                >
                  <FormSelect placeholder={"2 Days"} border={"none"} />
                </Td>
                <Td
                  px={1}
                  borderRight="1px"
                  borderColor="gray.200"
                  textAlign={"center"}
                >
                  <FormCheckBox label={""} colorScheme="blue" />{" "}
                </Td>
                <Td
                  px={1}
                  borderRight="1px"
                  borderColor="gray.200"
                  textAlign={"center"}
                >
                  <FormCheckBox label={""} colorScheme="blue" />{" "}
                </Td>
                <Td
                  px={1}
                  borderRight="1px"
                  borderColor="gray.200"
                  textAlign={"center"}
                >
                  <FormCheckBox label={""} colorScheme="blue" />{" "}
                </Td>
                <Td
                  px={1}
                  borderRight="1px"
                  borderColor="gray.200"
                  className={"center_flex"}
                >
                  <InputGroup maxW={"120px"}>
                    <Input
                      _focusVisible={{
                        border: 0,
                      }}
                      defaultValue={0}
                      type={"number"}
                      border={"none"}
                    />
                    <InputRightAddon
                      bg="white"
                      color="brand.500"
                      border="none"
                      px={0}
                    >
                      <BsCurrencyDollar />
                    </InputRightAddon>
                  </InputGroup>
                </Td>
                {index > 0 && packages.length - 1 === index && (
                  <Td>
                    <IconButton
                      onClick={() => {
                        setPackages((prevState) => {
                          const arr = [...prevState];
                          arr.pop();
                          console.log(arr);
                          return arr;
                        });
                      }}
                    >
                      <ImBin />
                    </IconButton>
                  </Td>
                )}
              </Tr>
            );
          })}
          {packages.length !== 3 && (
            <Tr>
              <Td px={1} colSpan={10} borderRight="1px" borderColor="gray.200">
                <HStack
                  cursor={"pointer"}
                  lineHeight={"normal"}
                  alignItems={"center"}
                  gap={2}
                  p={2}
                  onClick={() => {
                    setPackages((prevState) => {
                      if (prevState.length === 1) {
                        return [...prevState, "Standard"];
                      } else if (prevState.length === 2) {
                        return [...prevState, "Premium"];
                      } else {
                        return prevState;
                      }
                    });
                  }}
                >
                  <AiFillPlusCircle color="#008ddb" fontSize={"24px"} />
                  <Text color="#008ddb">Add Packages</Text>
                </HStack>
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>

      <Box display={{ base: "block", md: "none" }}>
        <Grid templateColumns="2fr 5fr">
          <Box
            minHeight="70px"
            borderWidth="1px"
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Text lineHeight={"normal"}>Basic</Text>
          </Box>
          <Box minHeight="70px" borderWidth="1px" className="center_flex">
            <Box
              cursor={"pointer"}
              lineHeight={"normal"}
              display={"flex"}
              alignItems={"center"}
              gap={2}
              p={2}
            >
              <AiFillPlusCircle color="#008ddb" fontSize={"24px"} />
              <Text color="#008ddb">Add Packages</Text>
            </Box>
          </Box>
          <Box className="center_flex" minHeight="70px" borderWidth="1px"></Box>
          <Box className="center_flex" minHeight="70px" borderWidth="1px"></Box>

          <Box className="center_flex" minHeight="70px" borderWidth="1px"></Box>
          <Box className="center_flex" minHeight="70px" borderWidth="1px"></Box>

          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            <Text lineHeight={"normal"}> Delivery</Text>{" "}
          </Box>
          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            {" "}
            <Box lineHeight={"normal"}>
              <FormSelect placeholder={"2 Days"} border={"none"} />
            </Box>
          </Box>

          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            <Text lineHeight={"normal"}> Revisions</Text>{" "}
          </Box>
          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            {" "}
            <Box lineHeight={"normal"}>
              <FormSelect placeholder={"Unlimited"} border={"none"} />
            </Box>
          </Box>

          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            <Text lineHeight={"normal"}> No of Concepts</Text>{" "}
          </Box>
          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            {" "}
            <Box lineHeight={"normal"}>
              <FormSelect placeholder={"2 "} border={"none"} />
            </Box>
          </Box>

          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            <Text lineHeight={"normal"}> Vector File</Text>{" "}
          </Box>
          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            <Box lineHeight={"normal"}>
              {" "}
              <FormCheckBox label={""} colorScheme="blue" />
            </Box>
          </Box>

          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            <Text lineHeight={"normal"}> Printable File</Text>{" "}
          </Box>
          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            <Box lineHeight={"normal"}>
              {" "}
              <FormCheckBox label={""} colorScheme="blue" />
            </Box>
          </Box>

          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            <Text lineHeight={"normal"}> Source File</Text>{" "}
          </Box>
          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            <Box lineHeight={"normal"}>
              {" "}
              <FormCheckBox label={""} colorScheme="blue" />
            </Box>
          </Box>

          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            <Text lineHeight={"normal"}>Pricing</Text>{" "}
          </Box>
          <Box className="center_flex" minHeight="70px" borderWidth="1px">
            <Box
              gap={2}
              display={"flex"}
              alignItems={"center"}
              lineHeight={"normal"}
            >
              {" "}
              <InputGroup w={"50%"} bg={"rgba(0,141,219,0.11)"}>
                <Input defaultValue={0} type={"number"} border={"none"} />
                <InputRightAddon bg={"rgba(0,141,219,0.11)"}>
                  <BsCurrencyDollar />
                </InputRightAddon>
              </InputGroup>
            </Box>
          </Box>
        </Grid>
      </Box>
    </TableContainer>
  );
}
export default PakegesTable;
